import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'course-list',
};

const CourseApi = createApi({
  reducerPath: 'course-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getCourses: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.course.list, body),
    }),
    handleAbsorptionPeriod: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.course.handleAbsorptionPeriod,
        method: 'post',
        body: body,
      }),
    }),
    updateBizKnowledge: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.course.knowledge,
        method: 'post',
        body,
      }),
    }),
    activateCourse: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.course.activate,
        method: 'post',
        body,
      }),
    }),
    deactivateCourse: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.course.deactivate,
        method: 'post',
        body,
      }),
    }),
    archieveCourse: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.course.deactivate,
        method: 'post',
        body,
      }),
    }),
    participants: builder.query({
      query: (body) => apiHelper(Endpoints.participants.list, body),
    }),
    // editCourse: builder.mutation({
    //   invalidatesTags: [tagType(tags.list)],
    //   query: (body) => ({
    //     url: Endpoints.course.edit,
    //     method: 'post',
    //     body: body,
    //   }),
    // }),
    // deleteCourse: builder.mutation({
    //   invalidatesTags: [tagType(tags.list)],
    //   query: (body) => ({
    //     url: Endpoints.course.delete,
    //     method: 'post',
    //     body,
    //   }),
    // }),
  }),
});

export const {
  useGetCoursesQuery,
  useActivateCourseMutation,
  useArchieveCourseMutation,
  useDeactivateCourseMutation,
  useHandleAbsorptionPeriodMutation,
  useUpdateBizKnowledgeMutation,
  useParticipantsQuery,
} = CourseApi;
export { CourseApi };
